import { Role } from "./users.constants";

export enum TaskEvent {
  Complete = "complete",
  Acquire = "acquire",
  Submit = "submit",
  Accept = "accept",
  Reject = "reject",
  Cancel = "cancel",
}

export enum TaskType {
  AdHoc = "ad-hoc", // Arbitrary project tasks
  ProjectInvitation = "project-invitation", // HA is invited to participate in a project
  FirstToAcquire = "acquire-task", // Related to all first to Acquire task
  AcceptHAQCopy = "haq-acceptance", // HAQ is sent from HA to Sponsor for response
}

export enum TaskAssignType {
  AssignToAll = "ASSIGN_TO_ALL",
  FirstToAcquire = "FIRST_TO_ACQUIRE",
}

export enum TaskStatus {
  Acquired = "ACQUIRED",
  NotAcquired = "NOT_ACQUIRED",
  Pending = "PENDING",
  InProgress = "IN_PROGRESS",
  Complete = "COMPLETE",
  Cancelled = "CANCELLED",
}

export const ACTIVE_TASKS_STATUSES = [
  TaskStatus.Pending,
  TaskStatus.InProgress,
] as const;

export const RESOLVED_TASKS_STATUSES = [
  TaskStatus.Cancelled,
  TaskStatus.Complete,
] as const;

export const NUMBER_OF_VISIBLE_PRIORITY_TASKS = 5;

export const NUMBER_OF_VISIBLE_SUMMARY_TASKS = 3;

export const DEFAULT_TASKS_SORT = "active,desc;dueDate,asc;status";

export const CUSTOM_DUE_DATE_SORT = {
  asc: DEFAULT_TASKS_SORT,
  desc: "active,desc;dueDate,desc;status",
};

export const TASK_CANCELLATION_REASON_MAX_LENGTH = 255;

export const INVITATION_TASKS_ALERT_STORAGE_KEY = "invitationTasksAlert";

export enum ReassignAssigneeStep {
  Select,
  Reassign,
}

export const TASK_ASSIGNMENT_POSSIBLE_ROLES = [
  Role.ProjectManager,
  Role.ContentEditor,
  Role.ExpertReviewer,
];
